import React, { PropTypes } from 'react';
import Lightbox from 'react-images';

import Button from '../Button';

/**
 * Image gallery presentational component.
 * Implements react-images lightbox with minimal defaults.
 */
const ImageGallery = ({ buttonLabel, className, onButtonClick, ...props }) => (
  <div>
    <Button className={className} onClick={onButtonClick}>{buttonLabel}</Button>
    <Lightbox backdropClosesModal showImageCount={false} {...props} />
  </div>
);

ImageGallery.propTypes = {
  /**
   * String text label for button.
   */
  buttonLabel: PropTypes.string,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Function called on button click.
   */
  onButtonClick: PropTypes.func,
};

ImageGallery.defaultProps = {
  buttonLabel: 'Show Photos',
  className: '',
  onButtonClick: () => {},
};

export default ImageGallery;



// WEBPACK FOOTER //
// ./app/src/components/ImageGallery/index.jsx